import { useMemo } from 'react';

export function OrderTotals({ order }) {
  const totals = useMemo(() => {
    const formatAmount = (amount) => {
      if (!amount) return null;
      return `$${parseFloat(amount).toFixed(2)}`;
    };
    return [
      {
        label: 'Subtotal',
        amount: formatAmount(order.subtotalPriceV2?.amount),
      },
      {
        label: 'Refunded',
        amount: formatAmount(order.totalRefundedV2?.amount),
      },
      {
        label: 'Shipping',
        amount: formatAmount(order.totalShippingPriceV2?.amount),
      },
      { label: 'Tax', amount: formatAmount(order.totalTaxV2?.amount) },
      { label: 'Total', amount: formatAmount(order.totalPriceV2?.amount) },
    ];
  }, [order.id]);

  return (
    <div>
      {totals.map(({ label, amount }) => {
        if (label === 'Refunded' && !parseFloat(amount)) return null;
        return (
          <div
            key={label}
            className="grid grid-cols-[10fr_1fr] items-center gap-3 border-b border-b-border py-5 last:border-none md:gap-12"
          >
            <p className="text-label">{label}</p>

            <p
              className={`${
                label === 'Total' ? 'text-lg font-bold' : 'text-sm'
              }`}
            >
              {amount}
            </p>
          </div>
        );
      })}
    </div>
  );
}

OrderTotals.displayName = 'OrderTotals';
